export default __webpack_public_path__ + "static/media/wideCross.b68e4757.svg";